<template>
  <div class="all">
    <div class="main">
      <div class="title1">
        {{ title }}
      </div>
      <div class="from">
        <span>来源:</span><span>{{ from }}</span><span>{{ time }}</span>
      </div>
      <div class="title">
        <p>紫金迎改</p>
      </div>
      <div class="img">
        <img :src="imgTitle" class="img-title" alt="">
      </div>
      <div class="title2">
        <p>切实保护消费者合法权益</p>
      </div>
      <div class="img2">
        <img :src="imgTop" class="img-title2" alt="">
      </div>
      <div class="title3">
        <p>近日，银保监会印发《关于实施车险综合改革的指导意见》，3大主险10大附加险4项增值服务均有重大改革，将于9月19日正式实施。今天，我们就来说一说4项增值服务将会给消费者带来哪些福利。</p>
      </div>
      <div class="title4">
        <span>
          <strong> 条款解说</strong>
        </span>
      </div>
      <ul class="title4-ul">
        <li>投保机动车保险后，可投保增值服务特约条款；</li>
        <li>道路救援+安全检测+代为驾驶+代为送检</li>
        <li>消费者可全部投保，也可部分投保，</li>
        <li>保险人依照保险合同的约定，按照承保特约条款分别提供增值服务。</li>
      </ul>
      <div class="img3">
        <img :src=" change_01" alt="">
      </div>
      <div class="title4">
        <span>
          <strong> 服务更丰富，选择更自由</strong>
        </span>
      </div>
      <div class="content">
        <p class="content-title">
          <span>01</span><span>道路救援服务特约条款</span>
        </p>
        <ul class="content-title-ul1">
          <li> 单程50公里以内拖车；</li>
          <li> 送油、送水、送防冻液、搭电；</li>
          <li> 轮胎充气、更换轮胎；</li>
          <li> 车辆脱离困境所需的拖拽、吊车。</li>
        </ul>
        <div class="content-div1">
          <p>汽车在行驶途中遭遇抛锚、亏电和爆胎等<strong>突发状况</strong>时，选用<strong>专业道路救援</strong>可以获得专业、快速、便捷的救援服务，避免二次事故的发生。</p>
        </div>
        <div class="content-img">
          <img :src=" change_02" alt="">
        </div>
        <p class="content-title">
          <span>02</span><span>车辆安全检测特约条款</span>
        </p>
        <ul class="content-title-ul1">
          <li> 发动机检测（机油、空滤、燃油、冷却等）；</li>
          <li> 变速器检测；</li>
          <li> 转向系统检测（含车轮定位测试、轮胎动平衡测试）；</li>
          <li> 底盘检测；</li>
          <li> 轮胎检测；</li>
          <li> 汽车玻璃检测；</li>
          <li> 汽车电子系统检测（全车电控电器系统检测）；</li>
          <li> 蓄电池检测；</li>
          <li> 车辆综合安全检测。</li>
        </ul>
        <div class="content-div1">
          <p><strong>定期</strong>进行安全检查可以<strong>提高</strong>车辆的安全性、可靠性、动力性以及经济性，通过检测可以<strong>有效减少</strong>由于车辆安全设施不完善、车辆性能欠佳及技术状况不良所带来的安全隐患。</p>
        </div>
        <div class="content-img2">
          <img :src=" change_03" alt="">
        </div>
        <p class="content-title">
          <span>03</span><span>代为驾驶服务特约条款</span>
        </p>
        <div class="content-div2">
          <p>
            <span>
              保险期间内，保险人或其受托人根据被保险人请求，在被保险人或其允许的驾驶人因饮酒、服用药物等原因无法驾驶或存在重大安全驾驶隐患时提供单程30公里以内的短途代驾服务。
            </span>
          </p>
        </div>

        <div class="content-div3">
          <p><strong>大多数</strong>交通事故的发生，都是由于驾驶人的驾驶行为不当导致的。所以在驾驶人不符合驾驶条件的情况下，应当<strong>避免</strong>驾驶以保证交通安全。适时呼叫代驾，匹配高素质代驾司机，可以使出行安全更有保障。</p>
        </div>

        <div class="content-img3">
          <img :src=" change_04" alt="">
        </div>

        <p class="content-title">
          <span>04</span><span>代为送检服务特约条款</span>
        </p>
        <div class="content-div2">
          <p>
            <span>
              保险期间内，按照《中华人民共和国道路交通安全法实施条例》，被保险机动车需由机动车安全技术检验机构实施安全技术检验时，根据被保险人请求，由保险人或其受托人代替车辆所有人进行车辆送检。
            </span>
          </p>
        </div>

        <div class="content-div4">
          <p>汽车<strong>年检</strong>目的在于检查汽车主要技术状况，督促加强汽车的维护保养，使汽车经常处于<strong>完好状态</strong>，确保汽车行驶安全。汽车年检也可以<strong>防止</strong>一些违法行为的发生，如：确保车辆没有被非法改装过，还会<strong>杜绝</strong>一些“带病上路”的情况发生，<strong>避免</strong>给车主自身以及路上其他车辆和行人带来潜在的安全隐患。</p>
        </div>

        <div class="content-img4">
          <img :src=" change_05" alt="">
        </div>
      </div>

      <div class="end">
        <p><strong><span>专业服务，贴心守护，</span></strong></p>
        <p><strong><span>紫金保险为您带来有温度的服务，</span></strong></p>
        <p><strong><span>切实保护消费者权益。</span></strong></p>
      </div>

      <div class="img4">
        <img :src=" change_06" alt="">
      </div>

      <hr>

      <div class="img5">
        <img :src="change_end" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api.js'
export default {
  data() {
    return {
      title: '紫金迎改｜丰富车险增值服务，切实保护消费者权益',
      from: '原创',
      time: '2020-05-19  15:46',
      imgTitle: api.imgAllUrl + '/more_title.jpg',
      imgTop: api.imgAllUrl + '/more_top.png',
      change_01: api.imgAllUrl + '/change_01.jpg',
      change_02: api.imgAllUrl + '/change_02.jpg',
      change_03: api.imgAllUrl + '/change_03.jpg',
      change_04: api.imgAllUrl + '/change_04.jpg',
      change_05: api.imgAllUrl + '/change_05.jpg',
      change_06: api.imgAllUrl + '/more_06.jpg',
      change_end: api.imgAllUrl + '/more_end.gif'
    }
  }
}
</script>

<style lang="scss" scoped>
@import './public.scss'
</style>



// WEBPACK FOOTER //
// src/pages/Info/Change.vue